import base from '../dr-base'
import drMenu from './dr-menu.vue'

const schema = {
  ...base,

  $Type: 'dr-menu',
  name: 'Menu',
  group: 'Menu widgets',
  icon: 'bars',
  properties: {
    ...base.properties,
    Orientation: {
      name: 'vuetifyWidgets.dr-menu.orientation',
      type: 'string',
      default: 'horizontal',
      enum: [ {
        value: 'vertical',
        text: 'vuetifyWidgets.dr-menu.vertical'
      },{
        value: 'horizontal',
        text: 'vuetifyWidgets.dr-menu.horizontal'
      }]
    }
  }
}

export default {
  schema,
  component: drMenu
}

